import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Button, Space, Typography } from "antd";
import CustomModal from "components/CustomModal";

const { Text } = Typography;

function ImportErrorModal({
  visible,
  onCancel,
  onReUpload,
  errorReason = "File không đúng định dạng. Vui lòng tải lên file đúng mẫu hoặc kiểm tra lại định dạng file.",
  actions = ["BACK", "RE_UPLOAD_FILE"],
  errorFileURL,
  onDownloadError,
}) {
  const hasBackAction = actions.includes("BACK");
  const hasReUploadAction = actions.includes("RE_UPLOAD_FILE");
  const hasDownloadErrorAction = actions.includes("DOWNLOAD_ERROR_FILE");

  return (
    <CustomModal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={440}
      centered
      hideCancelButton
      hideConfirmButton
      style={{
        borderRadius: "16px",
      }}
      styles={{
        body: {
          padding: "32px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
      }}
    >
      <div style={{ textAlign: "center", width: "100%" }}>
        <Text
          style={{
            fontSize: "20px",
            fontWeight: 600,
            color: "#111827",
            display: "block",
            marginBottom: "16px",
          }}
        >
          Lỗi upload file thông tin khuyến mãi
        </Text>

        <ExclamationCircleOutlined
          style={{
            fontSize: "40px",
            color: "#F59E0B",
            display: "block",
            margin: "0 auto 16px",
          }}
        />

        <Text
          style={{
            fontSize: "14px",
            color: "#6B7280",
            lineHeight: "1.5",
            display: "block",
            marginBottom: "24px",
          }}
        >
          {errorReason}
        </Text>

        <Space size={12} style={{ width: "100%", justifyContent: "center" }}>
          {hasBackAction && (
            <Button
              onClick={onCancel}
              style={{
                backgroundColor: "#E5E7EB",
                color: "#374151",
                border: "none",
                borderRadius: "10px",
                padding: "10px 20px",
                height: "auto",
                fontWeight: 500,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#D1D5DB";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#E5E7EB";
              }}
            >
              Huỷ bỏ
            </Button>
          )}
          {hasDownloadErrorAction && (
            <Button
              onClick={() => {
                if (errorFileURL) {
                  window.open(errorFileURL, "_blank");
                }
                onDownloadError && onDownloadError();
              }}
              style={{
                backgroundColor: "#1953D8",
                color: "#FFFFFF",
                border: "none",
                borderRadius: "10px",
                padding: "10px 20px",
                height: "auto",
                fontWeight: 600,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#1547B0";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#1953D8";
              }}
            >
              Tải file lỗi
            </Button>
          )}
          {hasReUploadAction && (
            <Button
              type="primary"
              onClick={onReUpload}
              style={{
                backgroundColor: "#2563EB",
                borderRadius: "10px",
                padding: "10px 20px",
                height: "auto",
                fontWeight: 600,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#1D4ED8";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#2563EB";
              }}
            >
              Tải file khác
            </Button>
          )}
        </Space>
      </div>
    </CustomModal>
  );
}

export default ImportErrorModal;
